@if (title()) {
  <h2 class="text-xl font-bold md:hidden">Hitta mottagning</h2>

  <div [innerHTML]="content()"></div>

  <div class="w-full md:w-40">
    <app-ui-button
      (onClick)="expandSearchWidgetWithPlaceFocused($event)"
      [color]="'green'"
      [disabled]="false"
      [expanded]="'block'"
      [size]="'lg'"
      class="test-select-place-btn"
    >
      <app-ui-icon name="marker"></app-ui-icon>
      Välj plats
    </app-ui-button>
  </div>
}

